/*
 * Subscriptions Reducer
 *
 */
import { fromJS } from 'immutable';
import {
  GET_SUBSCRIPTIONS_ATTEMPT,
  GET_SUBSCRIPTIONS_SUCCESS,
  GET_SUBSCRIPTIONS_FAILURE,
  CLEAR_SUBSCRIPTIONS_LIST,
  SET_SELECTED_SUBSCRIPTION,
  SET_SEARCH_PARAMETERS,
  GET_SUBSCRIPTIONS_ATTEMPT_FOR_ACCOUNT,
  GET_SUBSCRIPTIONS_SUCCESS_FOR_ACCOUNT,
  GET_SUBSCRIPTIONS_FAILURE_FOR_ACCOUNT,
  CLEAR_STATE,
} from './constants';

export const initialState = fromJS({
  subscriptions: [],
  error: null,
  attempting: false,
  selectedSubscription: null,
  userToken: null,
  brand: null,
  userName: null,
  searchBy: null,
  subscriptionsForAccount: [],
  subscriptionsForAccountAttempting: false,
  subscriptionsForAccountError: null,
});

export default function subscriptionsListReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SUBSCRIPTIONS_ATTEMPT:
      return {
        ...state,
        attempting: true,
        subscriptions: [],
        brand: action.brand,
        userName: action.userName,
        searchBy: action.searchBy,
      };
    case GET_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        error: null,
        subscriptions: action.subscriptionsList,
        userToken: action.token,
        attempting: false,
      };

    case GET_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        error: action.error,
        attempting: false,
      };
    case SET_SELECTED_SUBSCRIPTION:
      return {
        ...state,
        selectedSubscription: action.subscription,
      };
    case SET_SEARCH_PARAMETERS:
      return {
        ...state,
        subscriptions: [],
        brand: action.brand,
        userName: action.userName,
      };
    case GET_SUBSCRIPTIONS_ATTEMPT_FOR_ACCOUNT:
      return {
        ...state,
        subscriptionsForAccountAttempting: true,
        subscriptionsForAccount: [],
      };
    case GET_SUBSCRIPTIONS_SUCCESS_FOR_ACCOUNT:
      return {
        ...state,
        subscriptionsForAccountError: null,
        subscriptionsForAccount: action.subscriptionsList,
        subscriptionsForAccountAttempting: false,
      };

    case GET_SUBSCRIPTIONS_FAILURE_FOR_ACCOUNT:
      return {
        ...state,
        subscriptionsForAccountError: action.error,
        subscriptionsForAccountAttempting: false,
      };
    case CLEAR_SUBSCRIPTIONS_LIST:
    case CLEAR_STATE:
      return initialState;

    default:
      return state;
  }
}
